import ActionTypes from '../constants/actionTypes';
import { store } from '../store';

export const resetApp = () => store.dispatch({ type: ActionTypes.RESET_APP });

export default {};
